// extracted by mini-css-extract-plugin
module.exports = {"header":"CookieChoice_header__PlVQa","header__name":"CookieChoice_header__name__7S1kh","desc":"CookieChoice_desc__z5iiH","first_component":"CookieChoice_first_component__ovxC7"};